import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../utils/translations';
import { heroImage } from '../utils/mockData';
import { Button } from './ui/button';
import { ArrowRight, MessageCircle } from 'lucide-react';

const Hero = () => {
  const { language } = useLanguage();
  const t = translations[language];
  const isRTL = language === 'ar';

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const openWhatsApp = () => {
    window.open('https://wa.me/905346635111', '_blank');
  };

  return (
    <section id="home" className="relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="Container ship"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#003d5c]/95 via-[#003d5c]/85 to-[#003d5c]/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 text-white">
        <div className={`max-w-3xl ${isRTL ? 'mr-auto text-right' : 'ml-auto text-left'}`}>
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight animate-fade-in">
            {t.hero.title}
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-gray-100 leading-relaxed">
            {t.hero.subtitle}
          </p>
          <div className={`flex flex-col sm:flex-row gap-4 ${isRTL ? 'justify-end' : 'justify-start'}`}>
            <Button
              size="lg"
              onClick={scrollToContact}
              className="bg-white text-[#003d5c] hover:bg-gray-100 text-lg px-8 py-6 transition-all duration-300 hover:scale-105 shadow-xl"
            >
              {t.hero.cta}
              <ArrowRight className={`h-5 w-5 ${isRTL ? 'mr-2' : 'ml-2'}`} />
            </Button>
            <Button
              size="lg"
              variant="outline"
              onClick={openWhatsApp}
              className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-[#003d5c] text-lg px-8 py-6 transition-all duration-300 hover:scale-105 shadow-xl"
            >
              <MessageCircle className={`h-5 w-5 ${isRTL ? 'ml-2' : 'mr-2'}`} />
              {t.hero.whatsapp}
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;